export default {
  en: {
    actions: {
      item: 'Item',
      service: 'Service',
    },
    title: 'Create a new offering',
  },
};
